import type { FC } from "react";
import { Navigate } from "react-router";
import { appPaths } from "../app/appPaths.js";
import {
  determineDefaultWorkspaceId,
  WorkspaceId,
} from "../app/navigation/workspaces.js";
import { useMainNavigationFeatureFlags } from "../helpers/mainNavigation.js";
import { AllProjectsPage } from "./allProjectsPage.js";

export const HomePage: FC = () => {
  const flags = useMainNavigationFeatureFlags();

  switch (determineDefaultWorkspaceId(flags)) {
    case WorkspaceId.Performance:
      return <Navigate to={appPaths.playbooks.build()} />;
    case WorkspaceId.Training:
      return <Navigate to={appPaths.trainings.build()} />;
    default:
      return <AllProjectsPage />;
  }
};
